<template>
  <div class="GoodColorSet">
    <el-dialog
      :visible.sync="goodColorSetShow"
      :before-close="handleDialogClose"
      :show-close="false"
      :destroy-on-close="true"
    >
      <i class="el-icon-close" @click="closeDialog"></i>

      <div class="bottom-pannel" style="padding: 20px;">
        <el-form ref="form" :model="color" label-width="80px">
          <el-form-item label="颜色标题">
            <name-lang :edit_lan="color.product_name" @lang_change="title_lang_change"></name-lang>
          </el-form-item>

          <!-- 新增：SKU货号、是否上架开关 -->
          <el-form-item label="库存">
            <el-input 
                v-model.number="color.product_number" 
                placeholder="库存数，默认为商品库存"
                type="number"
                :min="0"
            ></el-input>
        </el-form-item>
        <el-form-item label="售价">
            <el-input 
                v-model.number="color.price" 
                placeholder="售价，单位元，不填默认为商品售价"
                type="number"
                :min="0"
            ></el-input>
        </el-form-item>
          <el-form-item label="是否上架">
            <el-switch
              active-color="#13ce66"
              inactive-color="#A3A3A3"
              v-model="color.is_on_sale"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
          </el-form-item>

          <el-form-item label="封面">
            <img v-if="color.product_cover.length" :src="`${baseURL}/${color.product_cover}`" class="avatar" />
            <el-button type="primary" @click="cover_upload" style="margin-top: 20px;">
              上传<i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-form-item>

          <el-form-item label="图片">
            <div class="pics" style="display: flex;flex-wrap: wrap;">
              <div
                v-for="pic in color.pics_array"
                style="margin-left:10px;margin-bottom: 10px;position: relative;display: inline-block;"
                :key="pic"
              >
                <img
                  :src="`${baseURL}/${pic}?q=30`"
                  v-if="pic.length"
                  class="avatar"
                  style="object-fit: cover;"
                />
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  style="position: absolute;top: 0;right: 0"
                  @click="delete_img(pic)"
                  circle
                ></el-button>
              </div>

              <div
                class="pic-add avatar"
                style="background-color: lightgray; display: flex;align-items: center;justify-content: center;margin-left:10px;"
                @click="pic_upload"
              >
                <i class="el-icon-plus" style="font-size: 40px;"></i>
              </div>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onAlter">确定</el-button>
            <el-button @click="onCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <photo-center
      :photoCenterShow="photoCenterShow"
      :maxselected_num="maxselected_num"
      @closeDialog="closePhotoCenter"
    ></photo-center>
  </div>
</template>

<script>
import { PhotoChooseType } from "../../system/config";
import NameLang from "../Lang/NameLang.vue";
import PhotoCenter from "@/components/PhotoCenter/PhotoCenter.vue";
import { baseURL } from "../../api/api";
import { event_msg_keys } from "../../eventbus/eventkeys";

export default {
  name: "good-color-set",
  components: {
    PhotoCenter,
    NameLang,
  },
  props: {
    goodColorSetShow: {
      type: Boolean,
      default: false,
    },
    color: {
      type: Object,
      default: () => ({
        id: 0,
        product_name: "",
        product_cover: "",
        product_pics: "",
        pics_array: [],
        // 新增字段默认值
        product_number: 999,
        is_on_sale: 1,
      }),
    },
  },
  watch: {
    goodColorSetShow(show) {
      if (!show) {
        // 弹窗关闭全部重置
        this.color.id = 0;
        this.color.product_name = "";
        this.color.product_cover = "";
        this.color.product_pics = "";
        this.color.pics_array = [];
        this.color.product_number = 999;
        this.color.is_on_sale = 1;
      }
    },
    color(newV) {
      const pics_array = newV.product_pics.split(",").filter(item => item.trim());
      this.color.pics_array = pics_array;
    },
  },
  data() {
    return {
      photoCenterShow: false,
      maxselected_num: 1,
      photo_select_type: PhotoChooseType.Unknow,
      baseURL,
    };
  },
  mounted() {
    this.$evt.on(event_msg_keys.img_selected_submit_noti, this.img_selected_submit_callback);
  },
  destroyed() {
    // 修复bug：取消事件监听，防止重复触发
    this.$evt.off(event_msg_keys.img_selected_submit_noti, this.img_selected_submit_callback);
  },
  methods: {
    handleDialogClose() {
      console.log("handleDialogClose");
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    cancel_pick() {
      this.$emit("closeDialog");
    },
    closePhotoCenter() {
      this.photoCenterShow = false;
      this.photo_select_type = PhotoChooseType.Unknow;
    },
   img_selected_submit_callback(e){
    const selected_imgs = e.imgs;
    this.photoCenterShow = false;
    switch (this.photo_select_type) {
        case PhotoChooseType.Color_Cover:
        this.color.product_cover = selected_imgs[0].source;
        break;
        case PhotoChooseType.Color_Photo:
        const pics_array = selected_imgs.map(item => item.source);
        // 合并并过滤空
        let all = [...new Set([...this.color.pics_array, ...pics_array])].filter(v=>v.trim())
        this.color.pics_array = all;
        this.color.product_pics = this.color.pics_array.join(",");
        break;
        case PhotoChooseType.Color_Editor:
        break;
        default:
        break;
    }
    this.photo_select_type = PhotoChooseType.Unknow;
    },
    cover_upload() {
      this.photo_select_type = PhotoChooseType.Color_Cover;
      this.maxselected_num = 1;
      this.photoCenterShow = true;
    },
    pic_upload() {
      this.photo_select_type = PhotoChooseType.Color_Photo;
      this.maxselected_num = 999;
      this.photoCenterShow = true;
    },
    title_lang_change(json_lans) {
      this.color.product_name = JSON.stringify(json_lans);
    },
    onAlter() {
      if (!this.color.product_name.length) {
        this.$message({
          message: "颜色标题不能为空",
          type: "error",
        });
        return;
      }
      if (!this.color.product_cover.length) {
        this.$message({
          message: "封面不能为空",
          type: "error",
        });
        return;
      }
      // 深拷贝传给父组件，切断引用
      this.$emit("okColorEdit", JSON.parse(JSON.stringify(this.color)));
    },
    onCancel() {
      this.$emit("closeDialog");
    },
    delete_img(pic) {
        this.color.pics_array = this.color.pics_array.filter(exist_pic => exist_pic !== pic && exist_pic.trim());
        this.color.product_pics = this.color.pics_array.join(",");
    }
  },
};
</script>

<style lang="less" src="./GoodColorSet.less"></style>